export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const eventsAPI = {
  async createEvent(formData: any) {
    const response = await fetch(`${API_URL}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const contentType = response.headers.get("content-type") || "";
    const data = contentType.includes("application/json")
      ? await response.json()
      : await response.text();

    if (!response.ok) {
      // throw the API payload so catch() can access code/message/meta
      throw data;
    }

    return data;
  },

  async updateEvent(formData: any, id: string) {
    const response = await fetch(`${API_URL}/events/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Event creation failed!");
    }

    return response.json();
  },

  async getEventsByUser(userId: string) {
    const response = await fetch(`${API_URL}/events/user/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch events!");
    }

    return await response.json();
  },

  async countEventsByUser(userId: string) {
    const response = await fetch(`${API_URL}/events/count/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch events!");
    }

    return await response.json();
  },

  async getEventById(eventId: string) {
    const response = await fetch(`${API_URL}/events/${eventId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch events!");
    }

    return await response.json();    
  },

  async getEventTaskCompletionRates(userId: string){

    const response = await fetch(`${API_URL}/events/taskcompletion/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch event task completion rate!");
    }

    return await response.json();  
  },

  async getEventSummary(eventId: string){
    const response = await fetch(`${API_URL}/events/summary/${eventId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch event summary for event with id ${eventId}!`);
    }

    return await response.json();  
  }
};
